import jQuery from 'jquery';

const scriptId = 'google-maps-api-script';
const status = {
	deferred: undefined
};

window.onLoadGoogleMapsApi = function(){
	status.deferred.resolve();
}

const loadGoogleMapsApi = function(version, key){
	if(typeof status.deferred !== 'undefined'){
		return status.deferred.promise();
	}else{
		const lang = jQuery('html').attr('lang');
		const splittedLang = lang.split('-');
		
		//Load script
		const scriptTag = jQuery('<script/>');
		scriptTag.attr('id', scriptId);
		scriptTag.attr('src', 'https://maps.googleapis.com/maps/api/js?language=' + splittedLang[0] + '&v=' + version + '&callback=onLoadGoogleMapsApi&key=' + key);
		
		jQuery('body').append(scriptTag);
		
		const deferred = jQuery.Deferred();
		status.deferred = deferred;
		
		return deferred;
	}
};

export default loadGoogleMapsApi;